// @flow
/**
 * Cricket Team Selection Logic
 * Batsman ->
 *        Min : 3
 *        Max : 6
 * Bowler ->
 *        Min : 3
 *        Max : 6
 * AllRounders ->
 *        Min : 1
 *        Max : 4
 * WK ->
 *      Min : 1
 *      Max : 4
 *
 * and maximum 7 players from the one team
 */
import '../../cricket/create_team/index_web.css';
import { SyntheticEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteLocation, useLink } from 'react-router-stack';
import { showErrorToast, showToast } from '../../../actions/app-actions-types';
import {
  addSubstitutePlayer,
  fantasyMatchClick,
  getPlayerList
} from '../../../actions/fantasy-substitute-action-types';
import {
  EmptyData,
  ErrorMessage,
  HeaderWithTimer,
  PlaceHolder,
  RouteWrapper,
  ScreenBackground,
  View
} from '../../../component';
import EventEmitter from '../../../utilities/EventEmitter';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import {
  CreateTeamBottomContainer,
  CreateTeamHeader,
  SubstituteTeamTabContent
} from '../../component';
import CreateTeamTabBar from '../../component/create_team_tab_bar';
import SwipeableViews from 'react-swipeable-views';
import { maskUserName } from '../../../utilities/helper';
import Constants from '../../../constants';

const SubstituteTeamPlayer = () => {
  const navigate = useLink();
  const { state } = useRouteLocation();
  const dispatch = useDispatch();
  const { FantasyTheme: theme } = useTheme();
  const { item: matchItem = {} } = useSelector((state: any) => state.fantasy_substitute);
  const { firstName = '', lastName = '', teamName = '' } = useSelector((state: any) => state.user);
  const [activeTab, setActiveTab] = useState(0);

  const [keeperList, setKeeperList] = useState([] as any[]);
  const [batsmanList, setBatsmanList] = useState([] as any[]);
  const [allRounderList, setAllRounderList] = useState([] as any[]);
  const [bowlerList, setBowlerList] = useState([] as any[]);

  const [sortName, setSortName] = useState('CREDITS');
  const [sortType, setSortType] = useState('DOWN');

  const [selectedKeeper, setSelectedKeeper] = useState(0);
  const [selectedBatsman, setSelectedBatsman] = useState(0);
  const [selectedBowler, setSelectedBowler] = useState(0);
  const [selectedAllRounder, setSelectedAllRounder] = useState(0);

  const [keeperListDisable, setKeeperListDisable] = useState(false);
  const [batsmanListDisable, setBatsmanListDisable] = useState(false);
  const [allRounderListDisable, setAllRounderListDisable] = useState(false);
  const [bowlerListDisable, setBowlerListDisable] = useState(false);

  const [teamAPlayersCount, setTeamAPlayersCount] = useState(0);
  const [teamBPlayersCount, setTeamBPlayersCount] = useState(0);

  const [totalCreditCount, setTotalCreditCount] = useState(100);
  const [resultArrived, setResultArrived] = useState(false);
  const [error, setError] = useState(false);
  const [lineupsOut, setLineupsOut] = useState(false);

  const [routes] = useState([
    { key: 'W/K', title: 'W/K', totalSelectedPlayer: [1, 2, 3, 4] },
    { key: 'BAT', title: 'BAT', totalSelectedPlayer: [1, 2, 3, 4, 5, 6] },
    { key: 'A/R', title: 'A/R', totalSelectedPlayer: [1, 2, 3, 4] },
    { key: 'BOW', title: 'BOW', totalSelectedPlayer: [1, 2, 3, 4, 5, 6] }
  ]);

  const {
    secondInningsPlayerList = [],
    originalPlayerList = [],
    isEdit = true,
    isClone = false,
    teamData = {},
    oldPlayerData = {},
    captainId = '',
    viceCaptainId = '',
    teamId = '',
    substitutedPlayers = {},
    substitutionPlayers = {},
    substitutedPlayersList = [],
    substitutedCaptainId = '',
    substitutedViceCaptainId = '',
    // teamAFInningsPlayerCount = 0,
    // teamBFInningsPlayerCount = 0,
    teamASInningsPlayerCount = 0,
    teamBSInningsPlayerCount = 0
  } = state as any;

  const teamNumber = teamData?.teamNumber || 1;

  const { _id: matchId, teamA = {}, teamB = {} } = matchItem;

  const onPressContinue = () => {
    const players = [...keeperList, ...batsmanList, ...allRounderList, ...bowlerList];

    let myTotalSelectedPlayers: any[] = [];
    players.forEach((item: any) => {
      if (item.isSelected === 'true') {
        myTotalSelectedPlayers.push(item);
      }
    });
    let newAddPlayerObj: any = {};
    myTotalSelectedPlayers.forEach((playerItem) => {
      const myItem = originalPlayerList.find(
        (item: { playerId: any }) => item.playerId === playerItem.id
      );
      if (!myItem) {
        newAddPlayerObj = {
          playerId: playerItem.id,
          state: 0
        };
      }
    });

    let data: any = {
      teamId,
      captainId,
      viceCaptainId,
      substitutedCaptainId,
      substitutedViceCaptainId
    };

    let playersAPIDataList: any[] = [];
    originalPlayerList.map((item: { playerId: any; substitutePlayerId: any }) => {
      let playerItem = {};
      if (item.playerId === oldPlayerData.id) {
        playerItem = {
          playerId: item.playerId,
          state: 0,
          substitutePlayerId: newAddPlayerObj.playerId
        };
      } else if (item.substitutePlayerId) {
        playerItem = {
          playerId: item.playerId,
          state: 0,
          substitutePlayerId: item.substitutePlayerId
        };
      } else {
        playerItem = {
          playerId: item.playerId,
          state: 0
        };
      }
      playersAPIDataList.push(playerItem);
    });
    playersAPIDataList.push(newAddPlayerObj);

    if (captainId === oldPlayerData.id) {
      data = {
        ...data,
        substitutedCaptainId: newAddPlayerObj.playerId
      };
    } else if (viceCaptainId === oldPlayerData.id) {
      data = {
        ...data,
        substitutedViceCaptainId: newAddPlayerObj.playerId
      };
    }
    myTotalSelectedPlayers = [...myTotalSelectedPlayers, ...substitutedPlayersList];
    if (teamAPlayersCount + teamBPlayersCount === 11) {
      if (selectedKeeper < 1) {
        dispatch(showErrorToast(I18n.t('MinimumWKCricket')));
      } else if (selectedKeeper > 4) {
        dispatch(showErrorToast(I18n.t('YouCanSelectMaximumWK')));
      } else if (selectedBatsman < 3) {
        dispatch(showErrorToast(I18n.t('MinimumBatsmanCricket')));
      } else if (selectedBatsman > 6) {
        dispatch(showErrorToast(I18n.t('MaximumBatsmanCricket')));
      } else if (selectedAllRounder < 1) {
        dispatch(showErrorToast(I18n.t('MinimumAllRounderCricket')));
      } else if (selectedAllRounder > 4) {
        dispatch(showErrorToast(I18n.t('YouCanSelectMaximumAllRounder')));
      } else if (selectedBowler < 3) {
        dispatch(showErrorToast(I18n.t('MinimumBowlerCricket')));
      } else if (selectedBowler > 6) {
        dispatch(showErrorToast(I18n.t('YouCanSelectMaximumBowler')));
      } else if (teamAPlayersCount > 7 || teamBPlayersCount > 7) {
        dispatch(showErrorToast(I18n.t('YouCanSelectMaxPlayersFromOneTeam')));
      } else {
        data = {
          ...data,
          players: playersAPIDataList
        };
        dispatch(
          addSubstitutePlayer({
            data,
            callback: ({ error }: { error: any }) => {
              setError(false);
              if (!error) {
                EventEmitter.emit('SubstituteTeamPlayer', {
                  substituteTeamData: { isLoader: true }
                });
                EventEmitter.emit('teamUpdate', {});
                dispatch(showToast(I18n.t('substituteAddedSuccessfully')));
                try {
                  navigate.goBackView();
                } catch (err) {
                  navigate.go(-1);
                }
              } else {
                setError(true);
              }
            }
          })
        );
      }
    } else {
      dispatch(showErrorToast(I18n.t('MaxPlayersFromATeamCricket')));
    }
  };

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    let teamAPlayerCount = 0;
    let teamBPlayerCount = 0;
    let totalCredit = 100;
    let keeperCount = 0;
    let batsmanCount = 0;
    let allRounderCount = 0;
    let bowlerCount = 0;
    const data = {
      matchId
    };
    dispatch(
      getPlayerList({
        data,
        callback: ({ result = [], error }: { result: any; error: any }) => {
          setResultArrived(true);
          if (!error && result) {
            let data: any[] = [],
              allRounder: any[] = [],
              batsman: any[] = [],
              bowler: any[] = [],
              keeper: any[] = [];

            ///this is for calculate line up out
            let playingPlayersList = [];
            playingPlayersList = result.filter(
              (player: { playingEleven: boolean }) => player.playingEleven === true
            );

            if (isEdit || isClone) {
              for (let i = 0; i < secondInningsPlayerList.length; i++) {
                for (let j = 0; j < result.length; j++) {
                  if (secondInningsPlayerList[i].playerId === result[j].playerId) {
                    result[j].isSelected = 'true';
                    result[j].isNonSubstitutePlayer = 'true';
                    if (result[j].role === 'wk' || result[j].role === 'wkbat') {
                      keeperCount++;
                    }
                    if (result[j].role === 'bat') {
                      batsmanCount++;
                    }
                    if (result[j].role === 'bowl') {
                      bowlerCount++;
                    }
                    if (result[j].role === 'all') {
                      allRounderCount++;
                    }

                    if (result[j]?.teamId === teamA?.teamId) {
                      teamAPlayerCount++;
                      totalCredit = totalCredit - result[j].rating;
                    }
                    if (result[j]?.teamId === teamB?.teamId) {
                      teamBPlayerCount++;
                      totalCredit = totalCredit - result[j].rating;
                    }
                  }
                }
                data = result;
              }
            } else {
              data = result;
            }

            data.map((item) => {
              let isSelected = item.isSelected === 'true' ? 'true' : 'false';

              if (item.role === 'wk' || item.role === 'wkbat')
                keeper.push({
                  ...item,
                  isSelected
                });
              else if (item.role === 'bat')
                batsman.push({
                  ...item,
                  isSelected
                });
              else if (item.role === 'all')
                allRounder.push({
                  ...item,
                  isSelected
                });
              else if (item.role === 'bowl')
                bowler.push({
                  ...item,
                  isSelected
                });
            });

            const allRounderList = allRounder.sort((a, b) => b.rating - a.rating);
            const batsmanList = batsman.sort((a, b) => b.rating - a.rating);
            const bowlerList = bowler.sort((a, b) => b.rating - a.rating);
            const keeperList = keeper.sort((a, b) => b.rating - a.rating);

            setKeeperList(keeperList);
            setBatsmanList(batsmanList);
            setAllRounderList(allRounderList);
            setBowlerList(bowlerList);

            setTeamAPlayersCount(teamAPlayerCount);
            setTeamBPlayersCount(teamBPlayerCount);
            setTotalCreditCount(totalCredit);
            setSelectedKeeper(keeperCount);
            setSelectedBatsman(batsmanCount);
            setSelectedBowler(bowlerCount);
            setSelectedAllRounder(allRounderCount);
            setLineupsOut(playingPlayersList.length >= 15);
            setError(false);
            setInitialData({
              teamAPlayerCount,
              teamBPlayerCount,
              keeperCount,
              batsmanCount,
              bowlerCount,
              allRounderCount
            });
          } else {
            setError(true);
          }
        }
      })
    );
  }

  const setInitialData = ({
    teamAPlayerCount = 0,
    teamBPlayerCount = 0,
    keeperCount = 0,
    batsmanCount = 0,
    bowlerCount = 0,
    allRounderCount = 0
  }) => {
    let keeperCondition = false;
    let batsmanCondition = false;
    let allRounderCondition = false;
    let bowlerCondition = false;

    const actualCountKeeper = keeperCount;

    const actualCountBatsman = batsmanCount;

    const actualCountAllRounder = allRounderCount;

    let totalPlayers = teamAPlayerCount + teamBPlayerCount;
    let remainingPlayers = 11 - totalPlayers;

    const actualCountBowler = bowlerCount;
    let minimumPlayer = 8;
    minimumPlayer = actualCountKeeper >= 1 ? minimumPlayer - 1 : minimumPlayer;
    minimumPlayer = actualCountBatsman >= 3 ? minimumPlayer - 3 : minimumPlayer - selectedBatsman;
    minimumPlayer = actualCountAllRounder >= 1 ? minimumPlayer - 1 : minimumPlayer;
    minimumPlayer = actualCountBowler >= 3 ? minimumPlayer - 3 : minimumPlayer - actualCountBowler;

    let minimumKeeper = actualCountKeeper >= 1 ? 0 : 1;
    let minimumBatsman = actualCountBatsman >= 3 ? 0 : 3 - actualCountBatsman;
    let minimumAllRounder = actualCountAllRounder >= 1 ? 0 : 1;
    let minimumBowler = actualCountBowler >= 3 ? 0 : 3 - actualCountBowler;

    if (minimumKeeper <= 0 && minimumPlayer >= remainingPlayers) {
      keeperCondition = true;
    }
    if (minimumBatsman <= 0 && minimumPlayer >= remainingPlayers) {
      batsmanCondition = true;
    }

    if (minimumAllRounder <= 0 && minimumPlayer >= remainingPlayers) {
      allRounderCondition = true;
    }

    if (minimumBowler <= 0 && minimumPlayer >= remainingPlayers) {
      bowlerCondition = true;
    }

    setKeeperListDisable(keeperCondition);
    setBatsmanListDisable(batsmanCondition);
    setAllRounderListDisable(allRounderCondition);
    setBowlerListDisable(bowlerCondition);
  };

  const onPressPlayer = (item: { teamId?: any; rating?: any; isSelected: any; role?: any }) => {
    const { role, isSelected } = item;

    let keeperCondition = false;
    let batsmanCondition = false;
    let allRounderCondition = false;
    let bowlerCondition = false;

    const actualCountKeeper =
      selectedKeeper + (role === 'wk' || role === 'wkbat' ? (isSelected === 'true' ? -1 : +1) : 0);

    const actualCountBatsman =
      selectedBatsman + (role === 'bat' ? (isSelected === 'true' ? -1 : +1) : 0);

    const actualCountAllRounder =
      selectedAllRounder + (role === 'all' ? (isSelected === 'true' ? -1 : +1) : 0);

    const actualCountBowler =
      selectedBowler + (role === 'bowl' ? (isSelected === 'true' ? -1 : +1) : 0);

    const data =
      role === 'wk' || role === 'wkbat'
        ? [...keeperList]
        : role === 'bowl'
        ? [...bowlerList]
        : role === 'all'
        ? [...allRounderList]
        : [...batsmanList];

    let teamAPlayerCount = teamAPlayersCount;
    let teamBPlayerCount = teamBPlayersCount;

    let minimumPlayer = 8;
    minimumPlayer = actualCountKeeper >= 1 ? minimumPlayer - 1 : minimumPlayer;
    minimumPlayer =
      actualCountBatsman >= 3 ? minimumPlayer - 3 : minimumPlayer - actualCountBatsman;
    minimumPlayer = actualCountAllRounder >= 1 ? minimumPlayer - 1 : minimumPlayer;
    minimumPlayer = actualCountBowler >= 3 ? minimumPlayer - 3 : minimumPlayer - actualCountBowler;

    let teamACount = teamAPlayerCount;
    let teamBCount = teamBPlayerCount;
    let myTotalCredit = totalCreditCount;

    if (isSelected === 'false') {
      if (teamA?.teamId === item.teamId) {
        teamACount++;
        myTotalCredit = myTotalCredit - item.rating;
      }
      if (teamB?.teamId === item.teamId) {
        teamBCount++;
        myTotalCredit = myTotalCredit - item.rating;
      }
    } else {
      if (teamA?.teamId === item.teamId) {
        teamACount--;
        myTotalCredit = myTotalCredit + item.rating;
      }
      if (teamB?.teamId === item.teamId) {
        teamBCount--;
        myTotalCredit = myTotalCredit + item.rating;
      }
    }

    let totalPlayers = teamACount + teamBCount;
    let remainingPlayers = 11 - totalPlayers;

    let minimumKeeper = actualCountKeeper >= 1 ? 0 : 1;
    let minimumBatsman = actualCountBatsman >= 3 ? 0 : 3 - actualCountBatsman;
    let minimumAllRounder = actualCountAllRounder >= 1 ? 0 : 1;
    let minimumBowler = actualCountBowler >= 3 ? 0 : 3 - actualCountBowler;

    if (
      ///to handle maximum keeper
      (role === 'wk' || role === 'wkbat') &&
      actualCountKeeper >= 4
    ) {
      keeperCondition = true;
    }
    ///to handle minimum keeper if there is only one player left
    else if (role != 'wk' && actualCountKeeper < 1 && remainingPlayers <= 1 && minimumPlayer <= 1) {
      keeperCondition = true;
      allRounderCondition = true;
      bowlerCondition = true;
      keeperCondition = false;
    }
    //to handle other players
    else if (
      minimumKeeper <= 0 &&
      (role === 'wk' || role === 'wkbat') &&
      minimumPlayer >= remainingPlayers
    ) {
      ///check other minimum player
      keeperCondition = true;
      if (actualCountBatsman >= 3 && minimumPlayer >= remainingPlayers) {
        // setBatsmanListDisable(true)
        batsmanCondition = true;
      }
      if (actualCountBowler >= 3 && minimumPlayer >= remainingPlayers) {
        // setBowlerListDisable(true)
        bowlerCondition = true;
      }
      if (actualCountAllRounder >= 1 && minimumPlayer >= remainingPlayers) {
        // setAllRounderListDisable(true)
        allRounderCondition = true;
      }
    }
    if (
      ///to handle maximum batsman
      role === 'bat' &&
      actualCountBatsman >= 6
    ) {
      batsmanCondition = true;
    }
    ///to handle minimum batsman
    else if (
      role != 'bat' &&
      actualCountBatsman < 3 &&
      remainingPlayers < 4 - selectedBatsman &&
      minimumPlayer <= 3 - selectedBatsman
    ) {
      keeperCondition = true;
      batsmanCondition = false;
      allRounderCondition = true;
      bowlerCondition = true;
    }
    //to handle other players
    else if (minimumBatsman <= 0 && role === 'bat' && minimumPlayer >= remainingPlayers) {
      ///check other minimum player
      batsmanCondition = true;
      if (actualCountKeeper >= 1 && minimumPlayer >= remainingPlayers) {
        keeperCondition = true;
      }
      if (actualCountAllRounder >= 1 && minimumPlayer >= remainingPlayers) {
        allRounderCondition = true;
      }
      if (actualCountBowler >= 3 && minimumPlayer >= remainingPlayers) {
        bowlerCondition = true;
      }
    }
    if (
      ///to handle maximum all rounder
      role === 'all' &&
      actualCountAllRounder >= 4
    ) {
      allRounderCondition = true;
    }
    ///to handle minimum allRounder
    else if (
      role != 'all' &&
      actualCountAllRounder < 1 &&
      remainingPlayers <= 1 &&
      minimumPlayer <= 1
    ) {
      keeperCondition = true;
      batsmanCondition = true;
      allRounderCondition = false;
      bowlerCondition = true;
    }
    //to handle other players
    else if (minimumAllRounder <= 0 && role === 'all' && minimumPlayer >= remainingPlayers) {
      ///check other minimum player
      allRounderCondition = true;
      if (actualCountKeeper >= 1 && minimumPlayer >= remainingPlayers) {
        keeperCondition = true;
      }
      if (actualCountBatsman >= 3 && minimumPlayer >= remainingPlayers) {
        batsmanCondition = true;
      }
      if (actualCountBowler >= 3 && minimumPlayer >= remainingPlayers) {
        bowlerCondition = true;
      }
    }
    if (
      ///to handle maximum bowler
      role === 'bowl' &&
      actualCountBowler >= 6
    ) {
      bowlerCondition = true;
    }
    ///to handle minimum bowler
    else if (
      role != 'bowl' &&
      actualCountBowler < 3 &&
      remainingPlayers < 4 - selectedBowler &&
      minimumPlayer <= 3 - selectedBowler
    ) {
      keeperCondition = true;
      batsmanCondition = true;
      allRounderCondition = true;
      bowlerCondition = false;
    }
    //to handle other players
    else if (minimumBowler <= 0 && role === 'bowl' && minimumPlayer >= remainingPlayers) {
      ///check other minimum player
      bowlerCondition = true;
      if (actualCountKeeper >= 1 && minimumPlayer >= remainingPlayers) {
        keeperCondition = true;
      }
      if (actualCountBatsman >= 3 && minimumPlayer >= remainingPlayers) {
        batsmanCondition = true;
      }
      if (actualCountAllRounder >= 1 && minimumPlayer >= remainingPlayers) {
        allRounderCondition = true;
      }
    }

    if (isSelected === 'false') {
      item.isSelected = 'true';
      if (minimumKeeper <= 0 && minimumPlayer >= remainingPlayers) {
        keeperCondition = true;
      }
      if (minimumBatsman <= 0 && minimumPlayer >= remainingPlayers) {
        batsmanCondition = true;
      }

      if (minimumAllRounder <= 0 && minimumPlayer >= remainingPlayers) {
        allRounderCondition = true;
      }

      if (minimumBowler <= 0 && minimumPlayer >= remainingPlayers) {
        bowlerCondition = true;
      }
    } else {
      item.isSelected = 'false';
      if (minimumKeeper <= 0 && minimumPlayer >= remainingPlayers) {
        keeperCondition = true;
      }
      if (minimumBatsman <= 0 && minimumPlayer >= remainingPlayers) {
        batsmanCondition = true;
      }

      if (minimumAllRounder <= 0 && minimumPlayer >= remainingPlayers) {
        allRounderCondition = true;
      }

      if (minimumBowler <= 0 && minimumPlayer >= remainingPlayers) {
        bowlerCondition = true;
      }
    }

    if (role === 'wk' || role === 'wkbat') {
      setKeeperList(data);
    } else if (role === 'bowl') {
      setBowlerList(data);
    } else if (role === 'all') {
      setAllRounderList(data);
    } else if (role === 'bat') {
      setBatsmanList(data);
    }

    setKeeperListDisable(keeperCondition);
    setBatsmanListDisable(batsmanCondition);
    setAllRounderListDisable(allRounderCondition);
    setBowlerListDisable(bowlerCondition);
    setTeamAPlayersCount(teamACount);
    setTeamBPlayersCount(teamBCount);
    setTotalCreditCount(myTotalCredit);

    setSelectPlayer(role);
  };

  const setSelectPlayer = (role: string) => {
    let count = 0;
    const data =
      role === 'wk' || role === 'wkbat'
        ? [...keeperList]
        : role === 'bowl'
        ? [...bowlerList]
        : role === 'all'
        ? [...allRounderList]
        : [...batsmanList];
    data.map((i) => {
      if (i.isSelected === 'true') {
        count++;
      }
    });
    if (role === 'wk' || role === 'wkbat') setSelectedKeeper(count);
    else if (role === 'bowl') setSelectedBowler(count);
    else if (role === 'all') setSelectedAllRounder(count);
    else if (role === 'bat') setSelectedBatsman(count);
  };

  const onPressRetry = () => {
    setResultArrived(false);
    getData();
  };

  const renderWhenEmpty = () => {
    if (!resultArrived) return <PlaceHolder.Loader loadingMessage={''} />;
    if (error) return <ErrorMessage onPressRetry={onPressRetry} />;
    return <EmptyData message={I18n.t('NoPlayerFound')} />;
  };

  const onPressBack = () => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: false,
          joined: false,
          joinedMatch: false,
          contestId: '',
          entryFee: '',
          isTeamSwitch: false,
          myContestJoinedTeams: [],
          contestType: {}
        }
      })
    );
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
    return true;
  };

  const onPressTeamPreview = () => {
    const players = [...keeperList, ...batsmanList, ...allRounderList, ...bowlerList];
    const selectedPlayers: any[] = [];
    players.map((item) => {
      if (item.isSelected === 'true') {
        selectedPlayers.push({
          ...item
        });
      }
    });
    if (selectedPlayers.length > 0) {
      const myTeamData = {
        ...teamData,
        players: selectedPlayers
      };
      navigate.push('/substitute_team', {
        matchAllPlayersList: players,
        teamData: myTeamData,
        matchId,
        item: matchItem,
        fromCreateTeam: true,
        lineupsOut,
        teamNumber
      });
    } else {
      dispatch(showErrorToast(I18n.t('PleaseSelectAtLeastOnePlayerToSeePreview')));
    }
  };

  const onUpdateSortingList = ({
    keeperList,
    batsmanList,
    allRounderList,
    bowlerList,
    sortName,
    sortType
  }: any) => {
    const keeperList_ = [...keeperList];
    setKeeperList(keeperList_);
    const batsmanList_ = [...batsmanList];
    setBatsmanList(batsmanList_);
    const allRounderList_ = [...allRounderList];
    setAllRounderList(allRounderList_);
    const bowlerList_ = [...bowlerList];
    setBowlerList(bowlerList_);
    setSortName(sortName);
    setSortType(sortType);
  };

  const onPressPlayerMinus = () => {};

  const onChangeTabIndex = (index = 0) => {
    setActiveTab(index);
  };

  const onChangeTab = (_event: SyntheticEvent, activeTab: number) => {
    setActiveTab(activeTab);
  };

  const onCalledDeadline = () => {
    navigate.replace('/', { replace: true });
  };

  const counts = {
    'W/K': selectedKeeper,
    BAT: selectedBatsman,
    'A/R': selectedAllRounder,
    BOW: selectedBowler
  };

  const userName = `${maskUserName(firstName, lastName, teamName)} (T${teamNumber})`;

  return (
    <RouteWrapper>
      <ScreenBackground>
        <HeaderWithTimer
          onlyTimer={true}
          onPressBack={onPressBack}
          matchItem={matchItem}
          onCalledDeadline={onCalledDeadline}
          teamName={userName}
          gameType={Constants.GameType.FANTASY_SUBSTITUTION}
        />
        <View className={'create-team-container'}>
          <CreateTeamHeader
            counts={counts}
            teamACount={teamAPlayersCount}
            teamBCount={teamBPlayersCount}
            totalCreditCount={totalCreditCount}
            teamAName={teamA?.shortName}
            teamBName={teamB?.shortName}
            onPressPlayerMinus={onPressPlayerMinus}
            isSubstituteTeamPlayer={true}
          />
          <View className={'create-team-container'}>
            <CreateTeamTabBar
              onChangeTab={onChangeTab}
              activeTab={activeTab}
              counts={counts}
              routes={routes}
            />
            <div className="flat-list-outer-grow">
              <SwipeableViews
                className={'create-team-swipeable-view '}
                index={activeTab}
                onChangeIndex={onChangeTabIndex}>
                <View className="create-team-tab">
                  {activeTab === 0 && (
                    <SubstituteTeamTabContent
                      data={keeperList}
                      matchItem={matchItem}
                      onPressPlayer={onPressPlayer}
                      selectedTab={activeTab}
                      renderWhenEmpty={renderWhenEmpty}
                      keeperList={keeperList}
                      batsmanList={batsmanList}
                      allRounderList={allRounderList}
                      bowlerList={bowlerList}
                      sortName={sortName}
                      sortType={sortType}
                      onUpdateSortingList={onUpdateSortingList}
                      lineupsOut={lineupsOut}
                      keeperListDisable={keeperListDisable}
                      batsmanListDisable={batsmanListDisable}
                      allRounderListDisable={allRounderListDisable}
                      bowlerListDisable={bowlerListDisable}
                      teamAPlayersCount={teamAPlayersCount}
                      teamBPlayersCount={teamBPlayersCount}
                      totalCreditCount={totalCreditCount}
                      theme={theme}
                      oldPlayerData={oldPlayerData}
                      substitutedPlayers={substitutedPlayers}
                      teamASInningsPlayerCount={teamASInningsPlayerCount}
                      teamBSInningsPlayerCount={teamBSInningsPlayerCount}
                      substitutionPlayers={substitutionPlayers}
                    />
                  )}
                </View>
                <View className="create-team-tab">
                  {activeTab === 1 && (
                    <SubstituteTeamTabContent
                      data={batsmanList}
                      matchItem={matchItem}
                      onPressPlayer={onPressPlayer}
                      selectedTab={activeTab}
                      renderWhenEmpty={renderWhenEmpty}
                      keeperList={keeperList}
                      batsmanList={batsmanList}
                      allRounderList={allRounderList}
                      bowlerList={bowlerList}
                      onUpdateSortingList={onUpdateSortingList}
                      lineupsOut={lineupsOut}
                      keeperListDisable={keeperListDisable}
                      batsmanListDisable={batsmanListDisable}
                      allRounderListDisable={allRounderListDisable}
                      bowlerListDisable={bowlerListDisable}
                      teamAPlayersCount={teamAPlayersCount}
                      teamBPlayersCount={teamBPlayersCount}
                      totalCreditCount={totalCreditCount}
                      theme={theme}
                      oldPlayerData={oldPlayerData}
                      substitutedPlayers={substitutedPlayers}
                      teamASInningsPlayerCount={teamASInningsPlayerCount}
                      teamBSInningsPlayerCount={teamBSInningsPlayerCount}
                      sortName={sortName}
                      sortType={sortType}
                      substitutionPlayers={substitutionPlayers}
                    />
                  )}
                </View>
                <View className="create-team-tab">
                  {activeTab === 2 && (
                    <SubstituteTeamTabContent
                      data={allRounderList}
                      matchItem={matchItem}
                      onPressPlayer={onPressPlayer}
                      selectedTab={activeTab}
                      renderWhenEmpty={renderWhenEmpty}
                      keeperList={keeperList}
                      batsmanList={batsmanList}
                      allRounderList={allRounderList}
                      bowlerList={bowlerList}
                      sortName={sortName}
                      sortType={sortType}
                      onUpdateSortingList={onUpdateSortingList}
                      lineupsOut={lineupsOut}
                      keeperListDisable={keeperListDisable}
                      batsmanListDisable={batsmanListDisable}
                      allRounderListDisable={allRounderListDisable}
                      bowlerListDisable={bowlerListDisable}
                      teamAPlayersCount={teamAPlayersCount}
                      teamBPlayersCount={teamBPlayersCount}
                      totalCreditCount={totalCreditCount}
                      theme={theme}
                      oldPlayerData={oldPlayerData}
                      substitutedPlayers={substitutedPlayers}
                      teamASInningsPlayerCount={teamASInningsPlayerCount}
                      teamBSInningsPlayerCount={teamBSInningsPlayerCount}
                      substitutionPlayers={substitutionPlayers}
                    />
                  )}
                </View>
                <View className="create-team-tab">
                  {activeTab === 3 && (
                    <SubstituteTeamTabContent
                      data={bowlerList}
                      matchItem={matchItem}
                      onPressPlayer={onPressPlayer}
                      selectedTab={activeTab}
                      renderWhenEmpty={renderWhenEmpty}
                      keeperList={keeperList}
                      batsmanList={batsmanList}
                      allRounderList={allRounderList}
                      bowlerList={bowlerList}
                      sortName={sortName}
                      sortType={sortType}
                      onUpdateSortingList={onUpdateSortingList}
                      lineupsOut={lineupsOut}
                      keeperListDisable={keeperListDisable}
                      batsmanListDisable={batsmanListDisable}
                      allRounderListDisable={allRounderListDisable}
                      bowlerListDisable={bowlerListDisable}
                      teamAPlayersCount={teamAPlayersCount}
                      teamBPlayersCount={teamBPlayersCount}
                      totalCreditCount={totalCreditCount}
                      theme={theme}
                      oldPlayerData={oldPlayerData}
                      substitutedPlayers={substitutedPlayers}
                      teamASInningsPlayerCount={teamASInningsPlayerCount}
                      teamBSInningsPlayerCount={teamBSInningsPlayerCount}
                      substitutionPlayers={substitutionPlayers}
                    />
                  )}
                </View>
              </SwipeableViews>
            </div>
          </View>
          <CreateTeamBottomContainer
            onPressTeamPreview={onPressTeamPreview}
            onPressContinue={onPressContinue}
            isHideTeamPreview={false}
          />
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default SubstituteTeamPlayer;
